@let $prompt = prompt();
@let $state = state();
@let $creating = $state.create;

@if ($state.loading) {
  <spinner class="app-fillf"/>
} @else {
  <ng-template #settings>
    <div class="field-grid">
      @if ($creating) {
        <label>Name</label>
        <app-editable-text
          [control]="form.controls.name"
          editMode="always"
          placeholder="prompt-name"
        />
      }

      <label>Description</label>
      <app-editable-text
        [control]="form.controls.description"
        [editMode]="editMode()"
        placeholder="Prompt description"
        (saving)="savePrompt('description', $event)"
      />

      <label>Visibility</label>
      <app-editable
        [editMode]="editMode()"
        (saving)="savePrompt('visibility', $event, form.controls.visibility)"
        [valid]="$creating || (form.value['visibility'] != $prompt!.visibility)"
        >
        <app-visibility viewContent [value]="form.controls.visibility.value!"/>
        <app-visibility-selector editContent [control]="form.controls.visibility"/>
      </app-editable>

      <label>Version</label>
      <app-editable editMode="never">
        <input type="text" tabindex="-1" readonly viewContent [value]="$prompt?.version || 1">
      </app-editable>
    </div>

    <app-editable
      #prompt
      [editMode]="editMode()"
      class="app-fill"
      align="top"
      (saving)="savePromptContent($event)"
      (saved)="form.controls.initial_content.markAsPristine()"
      (canceled)="form.controls.initial_content.reset()"
      (editing)="prompt.focus(comment)"
    >
      <div editContent class="app-column-fill app-fill-last gapped stretched">
        <input type="text"
               #comment
               [class.hidden]="$creating"
               placeholder="Change comment"
        >

        <textarea
          [formControl]="form.controls.initial_content"
          placeholder="Enter your initial prompt content..."
        ></textarea>
      </div>

      @if (!$creating) {
        <app-markdown viewContent [content]="$prompt!.latestVersion!.content"/>
      }
    </app-editable>
  </ng-template>

  <app-page [heading]="$prompt?.name || 'New Prompt'">
    @if ($creating) {
      <ng-container [ngTemplateOutlet]="settings"/>

      <ng-template pageFooter>
        <app-button type="save" (clicked)="createPrompt()" [disabled]="form.invalid"/>
        <app-button type="cancel" [routerLink]="['..']"/>
      </ng-template>
    } @else {
      <ng-template pageTab="Settings" icon="settings">
        <ng-container [ngTemplateOutlet]="settings"/>
      </ng-template>

      <ng-template pageTab="Versions" icon="history">
        Coming soon...
      </ng-template>

      <ng-template pageTab="References" icon="references">
        Coming soon...
      </ng-template>
    }
  </app-page>

}
